













































import { Component, Prop, Vue } from "vue-property-decorator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { ACTIONS } from "@/event-bus";
import InputNumeric from "@/components/input/InputNumeric.vue";
library.add(faCaretDown);
import BN from "bn.js";

@Component({
  components: {
    FontAwesomeIcon,
    InputNumeric,
  },
})
export default class InputCurrency extends Vue {
  @Prop(Object) private value!: BN;
  @Prop(Object) private currency!: any;

  @Prop(Object) private minValue!: BN;
  @Prop(Object) private maxValue!: BN;

  @Prop(Boolean) private disabled!: boolean;
  @Prop(Boolean) private selector!: boolean;
  @Prop(Boolean) private maxButton!: boolean;

  @Prop({ default: "ether" }) private weiUnit!: string;

  private setInputValue(newVal: BN) {
    this.$emit(ACTIONS.UPDATE_VALUE, newVal);
  }

  private handleSelectorClick() {
    if (this.selector) {
      this.$emit(ACTIONS.CURRENCY_SELECT);
    }
  }
}
